module.exports = __webpack_public_path__ + "media/vedio.235390d2.mp4";